import React from "react";
import GameAssetCreatorStudio from "./studios/gameAssetCreator/GameAssetCreatorStudio";
import CharacterCreatorStudio from "./studios/characterCreator/CharacterCreatorStudio";
import ClothingTryOnStudio from "./studios/clothingTryOn/ClothingTryOnStudio";

// =============================================================================
// Studio Registry
// =============================================================================

export const STUDIOS = [
  {
    slug: "game-asset-creator",
    name: "Game Asset Creator",
    tagline: "Generate up to 10 game assets in parallel from one reference",
    description:
      "Describe what you want, upload a reference, and let an AI planner break it into distinct prompts. Each prompt generates its own asset in parallel — failures don't block the rest, and you can retry individual cards without re-running the whole workflow.",
    cover_url: null,
    category: "character",
    badge: "new",
    component: GameAssetCreatorStudio,
  },
  {
    slug: "character-creator",
    name: "Character Creator",
    tagline: "Create hyper-realistic full-body characters with fine-tuned control",
    description:
      "Choose gender, age, ethnicity, skin color, eye color, body type, hair, nose, skin conditions, and markings. " +
      "An AI enhancer builds a detailed prompt with randomized micro-features so no two characters are ever identical. " +
      "4K portrait, photorealistic skin, head to toe.",
    cover_url: null,
    category: "character",
    badge: "new",
    component: CharacterCreatorStudio,
  },
  {
    slug: "clothing-try-on",
    name: "Clothing Try-On",
    tagline: "Virtual try-on with accurate fabric physics for e-commerce",
    description:
      "Upload a garment, pick a character model or go modelless, choose an " +
      "environment, and get a photorealistic product shot with physically " +
      "accurate draping, wrinkles, and lighting.",
    cover_url: null,
    category: "marketing",
    badge: "new",
    component: ClothingTryOnStudio,
  },
];

/**
 * Look up a Studio definition by slug.
 * @param {string} slug
 */
export function getStudioBySlug(slug) {
  return STUDIOS.find((s) => s.slug === slug) || null;
}
